export function viewAiErrorMessage (error) {
  const data = error && error.response && error.response.data

  return (typeof data === 'string' && data) || (error && error.message) || 'AI request failed'
}

export async function submitViewAi (vm, event, { visibleKey, tabIndex }) {
  if (vm.activeTab !== tabIndex) return false

  event.preventDefault()

  const prompt = String(vm.aiPrompt || '').trim()

  if (!prompt) {
    vm.aiError = 'Describe the change you want.'
    return true
  }

  const page = vm.parentDesigner && vm.parentDesigner.page
  const pageUniqueTitle = page && page.uniqueTitle
  const applicationUniqueTitle = vm.applicationUniqueTitle
    || (vm.parentDesigner && vm.parentDesigner.$route && vm.parentDesigner.$route.params.application)

  if (!pageUniqueTitle || !applicationUniqueTitle) {
    vm.aiError = 'Open a page before updating this view.'
    return true
  }

  vm.aiError = null
  vm.aiSubmitting = true

  try {
    const response = await vm.$http.post(
      `${VUE_APP_PROXY_SERVER_URL}/ai-views/edit`,
      {
        pageUniqueTitle,
        viewUniqueTitle: vm.aiSavedUniqueTitle || vm.uniqueTitle,
        prompt
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'application-unique-title': applicationUniqueTitle
        },
        timeout: 600000
      }
    )

    if (vm.parentDesigner && response && response.data && response.data.page) {
      vm.parentDesigner.loadPage(response.data.page)
    }

    vm[visibleKey] = false
    vm.aiPrompt = ''
  } catch (error) {
    console.error('AI view update failed:', error)
    vm.aiError = viewAiErrorMessage(error)
  }

  vm.aiSubmitting = false
  return true
}
